// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"118":"c234bfb3","277":"54f05548","411":"62ce4790","453":"d9e4023f"}[chunkId] + ".chunk.js";
};